var Question = /** @class */ (function () {
    function Question() {
        this.id = null;
        this.prompt = "";
        this.display_order = 0;
        this.is_reversed = false;
        this.assessment_scale = null;
        this.skip_scoring = false;
        this._display_index = 0;
        this._flaggedCondition = null;
        this.isFlaggedForReview = false;
        this._computedScore = null;
    }
    Object.defineProperty(Question.prototype, "type", {
        get: function () {
            return this._type;
        },
        set: function (v) {
            this._type = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "display_index", {
        get: function () {
            return this._display_index;
        },
        set: function (v) {
            this._display_index = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (v) {
            this._id = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "prompt", {
        get: function () {
            return this._prompt;
        },
        set: function (v) {
            this._prompt = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "display_order", {
        get: function () {
            return this._display_order;
        },
        set: function (v) {
            this._display_order = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "is_reversed", {
        get: function () {
            return this._is_reversed;
        },
        set: function (v) {
            this._is_reversed = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "skip_scoring", {
        get: function () {
            return this._skip_scoring;
        },
        set: function (v) {
            this._skip_scoring = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "assessment_scale", {
        get: function () {
            return this._scale;
        },
        set: function (v) {
            this._scale = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "hasFlagCondition", {
        get: function () {
            return this._flaggedCondition != null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "flaggedCondition", {
        get: function () {
            return this._flaggedCondition;
        },
        set: function (value) {
            this._flaggedCondition = value;
        },
        enumerable: true,
        configurable: true
    });
    Question.prototype.setComputedScore = function (v) {
        this._computedScore = v;
    };
    Question.prototype.getComputedScore = function () {
        return this._computedScore;
    };
    Object.defineProperty(Question.prototype, "isFlaggedForReview", {
        get: function () {
            return this._is_flagged;
        },
        set: function (v) {
            this._is_flagged = v;
        },
        enumerable: true,
        configurable: true
    });
    return Question;
}());
export { Question };



// WEBPACK FOOTER //
// ./src/app/shared/models/question.ts.pre-build-optimizer.js